module.exports = __webpack_public_path__ + "assets/TrByAltitudeBases.4cc8a216005db4c215b9dd0bb24b01b8.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TrByAltitudeBases.gmt
// module id = 1019
// module chunks = 0